import apiClient from '@/lib/axios'

// =============================== ASSISTANTS ===============================

export const getAssistants = async (
  params: GetAssistantsRequest
): Promise<GetAssistantsResponse> => {
  const response = await apiClient.get('ai-hub/assistants', {
    params: {
      organization: params.organization,
      page: params.page,
      items_per_page: params.items_per_page,
      is_active: params.is_active,
    },
  })

  return response.data
}

export const getAssistantById = async (
  externalId: string
): Promise<GetAssistantByIdResponse> => {
  const response = await apiClient.get(`ai-hub/assistant/${externalId}`)

  return response.data
}

export const createAssistant = async (
  params: CreateAssistantRequest
): Promise<CreateAssistantResponse> => {
  const response = await apiClient.post('ai-hub/assistant', {
    name: params.name,
    description: params.description,
    preferences: params.preferences,
    integrations: params.integrations,
    knowledge_base: params.knowledge_base,
  })

  return response.data
}

export const uploadLogo = async (
  logoFile: File,
  versionId: string
): Promise<UploadLogoResponse> => {
  const formData = new FormData()
 
  formData.append('version_id', versionId)
  formData.append('file', logoFile)
  
  const response = await apiClient.post('/ai-hub/assistant/upload-logo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const deleteAssistants = async (
  params: DeleteAssistantsRequest
): Promise<DeleteAssistantsResponse> => {
  const response = await apiClient.delete('/ai-hub/assistant', {
    data: {
      external_ids: params.external_ids,
    },
  })

  return response.data
}

// =============================== VERSIONS ===============================

export const createVersion = async (
  assistantId: string,
  params: CreateVersionRequest
): Promise<CreateVersionResponse> => {
  const response = await apiClient.post(
    `/ai-hub/assistant/${assistantId}/versions`,
    {
      version_name: params.version_name,
      name: params.name,
      description: params.description,
      logo_url: params.logo_url,
      preferences: params.preferences,
      integrations: params.integrations,
      knowledge_base: params.knowledge_base,
      tools: params.tools,
    }
  )

  return response.data
}

export const deployVersion = async (
  assistantId: string,
  versionId: string
): Promise<DeployVersionResponse> => {
  const response = await apiClient.patch(
    `/ai-hub/assistant/${assistantId}/versions/${versionId}/deploy`
  )

  return response.data
}

export const getVersions = async (
  assistantId: string
): Promise<GetVersionsResponse> => {
  const response = await apiClient.get(
    `/ai-hub/assistant/${assistantId}/versions`
  )

  return response.data
}

export const getDeployedVersion = async (
  assistantId: string
): Promise<GetDeployedVersionResponse> => {
  const response = await apiClient.get(
    `/ai-hub/assistant/${assistantId}/versions/deployed`
  )

  return response.data
}

export const deleteVersion = async (
  params: DeleteVersionRequest
): Promise<DeleteVersionResponse> => {
  const response = await apiClient.delete(
    `/ai-hub/assistant/${params.assistant_id}/versions/${params.version_id}`
  )
  return response.data
}

// =============================== WHATSAPP ===============================

export const validateWhatsAppPhone = async (
  phoneNumber: string,
  assistantId: string
): Promise<WhatsAppPhoneValidationResponse> => {
  const response = await apiClient.post(
    `/whatsapp/assistant/validation_phone`,
    {
      phone: phoneNumber,
      assistant_id: assistantId,
    }
  )

  return response.data
}

export const getWhatsAppSessionStatus = async (
  sessionName: string
): Promise<WhatsAppSessionStatusResponse> => {
  const response = await apiClient.get(
    `/whatsapp/assistant/session-status/${sessionName}`
  )

  return response.data
}

export const refreshWhatsAppQRCode = async (
  sessionName: string
): Promise<WhatsAppQRCodeResponse> => {
  const response = await apiClient.post(
    `/whatsapp/assistant/refresh-qr/${sessionName}`
  )

  return response.data
}

export const deleteWhatsAppSession = async (
  sessionName: string
): Promise<void> => {
  await apiClient.delete(
    `/whatsapp/assistant/session/${sessionName}`
  )
}